import React from "react";
import {
  MDBNotification,
  MDBInputGroup,
  toast,
  MDBFormInline,
  MDBBadge,
  MDBAnimation,
  ToastContainer,
  MDBIcon,
  MDBDataTable,
  MDBAlert,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBBtnGroup,
} from "mdbreact";
import Loader from "../../Components/Loader";
import { API_CONFIG, casaideas_credentials } from "../../Config/config-env.js";
import { OP_SECRET_KEY } from "../../Config/config-env.js";
import axios from "axios";
import Table from "../../Components/Table";
import LockOverlay from "../../Components/LockOverlay";

import ReactExport from "react-export-excel-xlsx-fix";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class externalForm01 extends React.Component {
  state = {
    id_producto: -1,
    mensaje: "",
    montoEvento: 0,
    accion: "",
    isDeleted: false,
    quantity: 1,
    name: "",
    validOrders: [],
    formButtons: [],
    SKUcode: "3212567000066",
    productPrice: 0,
    existingPreviousOrder: false,
    isExecuting: false,
    processing: "Procesando",
    ordersPre: [
      {
        id: 0,
        product_id: 111,
        name: "Manta",
        productPrice: "50Bs.",
        quantity: "1",
        state: "loaded",
      },
      {
        id: 1,
        product_id: 112,
        name: "Juego de Tazas",
        productPrice: "50Bs.",
        quantity: "1",
        state: "loaded",
      },
    ],
    orders: [],
    customerinfo: [],
    addinfo: [],
    WO_Id: "",
    isLoadedTable: false,
    loadingData: true,
    modal4: false,
    modal3: false,
    order_id: "",
    orderName: "",
    orderPrice: "Bs.50",
    orderQty: "1",
    customerName: "",
    customerAdd: "",
    customerZone: "",
    productMaxQty: 0,
    disabledAdd: true,

    tableData: {
      columns: [
        { dataIndex: "EVENTID", enabled: true, title: "Codigo Evento" },
        { dataIndex: "orderid", enabled: true, title: "Pedido" },
        { dataIndex: "ORDERTYPE", enabled: true, title: "Tipo Pedido" },
        { dataIndex: "DATEADDED", enabled: true, title: "Fecha Pedido" },
        { dataIndex: "nombre_invitado", enabled: true, title: "Nombre Invitado" },
        { dataIndex: "dedicacion_invitado", enabled: true, title: "Dedicatoria" },
        { dataIndex: "TOTAL", enabled: true, title: "Monto Pedido" },
        { dataIndex: "SKU", enabled: true, title: "SKU" },
        { dataIndex: "QUANTITY", enabled: true, title: "Cantidad" },
        { dataIndex: "PRICE", enabled: true, title: "Precio Unitario" },
      ],
      rows: [],
    },
    locked: false,
  };

  componentDidMount = () => {
    console.log("1.2");
    require("antd/dist/antd.css");
    this.LoadTable();
  };

  changeHandler = (event) => {
    console.log(event.target.name);
    console.log(event.target.value);
    this.setState({ ...this.state, [event.target.name]: [event.target.value] });
  };

  handlePick = async (order) => {
    if (this.state.locked) return;
    let neworders = [];
    let order_ids = "";
    let totalProd = this.state.orders.length;
    let totalPicked = 0;
    this.setState({ isExecuting: true });
    for (var key in this.state.orders) {
      let obj = this.state.orders[key];
      //console.log(this.state.orders[key])

      if (this.state.orders[key].orderid === order) {
        obj["isPicked"] = this.state.orders[key].isPicked === -1 ? 1 : -1;
      }
      neworders.push(obj);
    }

    for (var key in neworders) {
      //console.log(neworders[key])
      if (neworders[key].isPicked === 1) {
        order_ids = order_ids + "," + neworders[key].orderid;
        totalPicked++;
      }
    }
    let progress = Math.ceil((totalPicked / totalProd) * 100);

    let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
    await axios({
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.token,
      },
      url: url,
      method: "put",
      data: {
        WO_flowID: this.state.WO_Id,
        WO_TaskID: this.state.WOTaskId,
        params: [
          { var: "ordersPicked", value: order_ids },
          { var: "progress", value: progress },
        ],
      },
    })
      .then((response) => response.data)
      .then((data) => {
        this.setState({ isExecuting: false, progress: progress });
      });

    this.setState({ isExecuting: false });
    this.setState({ orders: neworders });
  };

  handleChange = async (event) => {
    let neworders = [];
    let order_ids = "";
    let totalProd = this.state.orders.length;
    let totalPicked = 0;

    for (var key in this.state.orders) {
      let obj = this.state.orders[key];
      if (obj.orderid === Number(event.target.name)) {
        obj["posicion_rack"] = event.target.value;
      }
      neworders.push(obj);
    }

    this.setState({ orders: neworders });
  };

  handleSetRack = async (orderid) => {
    if (this.state.locked) return;
    console.log(orderid);

    this.setState({ isExecuting: true });
    var posicion_rack = "";
    var flowId = "";
    for (var key in this.state.orders) {
      if (this.state.orders[key].orderid == orderid) {
        posicion_rack = this.state.orders[key]["posicion_rack"];
        flowId = this.state.orders[key]["flowId"];
      }
    }

    console.log("flowId", flowId);
    let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
    await axios({
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.token,
      },
      url: url,
      method: "put",
      data: {
        WO_flowID: flowId,
        WO_TaskID: 0,
        params: [
          { var: "posicion_rack", value: posicion_rack },
        ],
      },
    })
      .then((response) => response.data)
      .then((data) => { });

    this.setState({ isExecuting: false });
  };

  LoadTable = async () => {
    let params = new URLSearchParams(this.props.location.search);
    let token = params.get("token");
    let WO_Id = params.get("wfpflowid");
    var flowcode;
    let formButtons = [];

    let officecode = params.get("officecode");
    let locked = params.get("locked") === "true";
    if (params.get("options")) {
      let options = params.get("options").split(",");
      console.log("options", options);
      for (let o in options) {
        formButtons.push({ optioncode: "op" + o, optionname: options[o] });
      }
    }
    let popup = params.get("popup");

    let isParent = false;

    if (popup) {
      console.log("popup", popup);
      this.setState({ reload: true });
    }

    let _WOTaskId = params.get("wfptaskid").split("___");

    let WOTaskId = _WOTaskId[0];

    if (_WOTaskId.length === 2) {
      console.log("es multiple");
      isParent = true;
    }

    var eventId = 0;
    var montoEvento = 0;
    var ordersPicked = [];
    var nombre_recepcion = "";
    var arr = [];
    var orderskus = [];
    var validOrders = [];
    var ordenes = [];
    var tipopedidos = [];
    var posicionracks = [];

    var customerinfo = [];
    var addinfo = [];
    var regalos = "";
    var isSupervisor, isAdmin, org, userId;

    var customer_id = 0;
    var picking_products = "";
    var progress = 0;
    let orders = [];

    this.setState({
      isLoadedTable: false,
      WO_Id: WO_Id,
      loadingData: true,
      isParent: isParent,
    });

    var isSupervisor, isAdmin;
    await axios({
      headers: {

        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      url: API_CONFIG.xflowurl + "/engine-users/decrypt-token",
      //url : "http://localhost:4042/api/v1"+"/engine-users/decrypt-token",
      method: "post",
    })
      .then((response) => response.data)
      .then((data) => {
        console.log("data", data);
        if (data.status) {
          userId = data.token.USERID;

          isSupervisor = data.token.USERGROUP === "SINGLEUSER" ? -1 : 1;
          isAdmin = data.token.USERGROUP === "ADMINECOM" ? 1 : -1;
          this.setState({
            ...this.state,
            username: data.token.USERNAME,
          });
        }
      });

    await axios({
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      url: API_CONFIG.xflowurl + "/engine-users/get-task-details",
      //url : "http://localhost:4042/api/v1"+"/engine-users/get-task-details",
      data: {
        wfptaskid: WOTaskId,
        isParent: isParent,
      },
      method: "post",
    })
      .then((response) => response.data)
      .then((data) => {
        console.log("data", data);

        if (data.task) {
          flowcode = data.task.FLOWCODE;
        }

        if (data.tasks) {
          flowcode = data.tasks[0].FLOWCODE;
        }

        if (data.status) {
          console.log("flowvars ", data.flowvars);

          for (let v in data.flowvars) {
            let flowVar = data.flowvars[v];
            let order_id = 0;
            let flowid = flowVar.WFPFLOWID;
            if (flowVar.VARNAME === "order_id") {
              order_id = Number(flowVar.VARVALUE);

              let customer_id = "";
              let pedido_parcial = "";
              let mixed_skus = [];
              for (let v2 in data.flowvars) {
                let flowVar2 = data.flowvars[v2];

                this.setState({ [flowVar2.VARNAME]: flowVar2.VARVALUE });

                if (flowVar2.WFPFLOWID == flowid) {
                  if (flowVar2.VARNAME === "customer_id") {
                    customer_id = flowVar2.VARVALUE;
                  }

                  if (flowVar2.VARNAME === "pedido_parcial") {
                    pedido_parcial = flowVar2.VARVALUE;
                  }

                  if (flowVar2.VARNAME === "mixed_skus") {
                    try {
                      mixed_skus = JSON.parse(flowVar2.VARVALUE);
                    } catch (ex) {
                      console.log("EX", ex);
                    }
                  }

                  if (flowVar2.VARNAME === "eventId") {
                    eventId = flowVar2.VARVALUE;
                  }

                  if (flowVar2.VARNAME == "nombre_recepcion") {
                    nombre_recepcion = flowVar2.VARVALUE;
                  }
                }
              }
              orders.push({
                order_id: order_id,
                customer_id,
                pedido_parcial,
                mixed_skus,
              });
              ordenes.push({
                ID_HFLUJO: flowid,
                NOMBRE: "order_id",
                VALOR: order_id,
              });
              validOrders.push(order_id);
            }

            if (flowVar.VARNAME === "tipo_pedido") {
              tipopedidos.push({
                ID_HFLUJO: flowid,
                NOMBRE: "tipo_pedido",
                VALOR: flowVar.VARVALUE,
              });
            }

            if (flowVar.VARNAME === "posicion_rack") {
              posicionracks.push({
                ID_HFLUJO: flowid,
                NOMBRE: "posicion_rack",
                VALOR: flowVar.VARVALUE,
              });
            }

            if (flowid == WO_Id) {
              if (flowVar.VARNAME === "ordersPicked") {
                ordersPicked = (flowVar.VARVALUE + "").split(",");
              }
              if (flowVar.VARNAME === "progress") {
                progress = parseInt(flowVar.VARVALUE);
              }
            }
          }
        }
      });

    console.log("progress", progress);
    console.log("orders", orders);
    console.log("validOrders", validOrders);
    console.log("ordenes", ordenes);
    console.log("posicionracks", posicionracks);
    console.log("tipopedidos", tipopedidos);

    var dataE = {
      id: eventId,
      apikey: API_CONFIG.casaideasIntToken
    };
    await axios({
      method: "post",
      url:
        API_CONFIG.casaideasInt +
        "/api/events/getById",
      data: dataE,
    })
      .then((response) => response.data)
      .then(async (data) => {
        if (data.success) {

          if (!data.response.ordenes) {
            data.response.ordenes = []
          }
          var d = data.response.datos_personales[0];
          customerinfo.push({ name: "nombre", value: d.firstname });
          customerinfo.push({ name: "apellido", value: d.lastname });
          customerinfo.push({ name: "Email", value: d.email });
          customerinfo.push({ name: "Telefono", value: d.phone });
          customerinfo.push({ name: "Documento", value: d.numdoc });

          var add = data.response.directions;
          regalos = data.response.regalosenvueltos;

          addinfo.push({ name: "Ciudad", value: add.city });
          addinfo.push({ name: "Dirección", value: add.address });
          addinfo.push({ name: "Indicaciones", value: add.reference });
          addinfo.push({ name: "Latitud", value: add.latitude });
          addinfo.push({ name: "Longitud", value: add.longitude });

          for (var key in data.response.ordenes) {
            let order = data.response.ordenes[key];
            let isPicked =
              ordersPicked.indexOf(String(order.orderid)) >= 0 ? 1 : -1;
            let products = [];
            let TOTAL = 0

            console.log("order.products::::::",order.orderid, order.products)
            for (let i in order.products) {
              let prod = order.products[i]
              console.log("-..............", prod)
              let match = data.response.productos.find(e => e.sku === prod.sku);
              if (!match) {
                console.log("buscamos regalo extra para", prod.sku)
                let url_path_prd_prod = process.env.REACT_APP_APIPRD_CONFIG
                const response = await axios.get(url_path_prd_prod, {
                  params: {
                    custom: true,
                    SKU: prod.sku
                  },
                  headers: {
                    "Content-Type": "application/json"
                  }
                });
                match = response.data.result[0];
                match.isExtra = true
              }

              prod.image = "https://cidev-media.s3.amazonaws.com" + match?.images_path + prod.sku + "_1.jpg"
              prod.price = match?.price
              prod.isExtra = match.isExtra
              prod.name = match?.specific_name
              prod.total = prod.quantity * (match.price ?? 0)
              products.push(prod);
              TOTAL += prod.total
            }

            montoEvento = montoEvento + TOTAL;

            if (validOrders.indexOf(Number(order.orderid)) >= 0) {
              arr.push({
                id: key,
                orderid: Number(order.orderid),
                fecha: order.DATEADDED,
                total: TOTAL,
                nombre: order.nombre_invitado,
                dedicacion_invitado: order.dedicacion_invitado,
                isPicked: isPicked,
                products: products,
              });
            }
          }
          console.log("validOrders", validOrders)

          const formatBoliviaDate = (unixTime) => {
            // Si viene en segundos, convertir a milisegundos
            if (unixTime.toString().length === 10) {
              unixTime *= 1000;
            }

            return new Intl.DateTimeFormat("es-BO", {
              timeZone: "America/La_Paz",
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false
            }).format(new Date(unixTime));
          };

          for (let i in data.response.ordenes) {
            let ordersku = data.response.ordenes[i]
            for (var key in ordersku.products) {
              let sku = ordersku.products[key]
             
              sku["DATEADDED"] = formatBoliviaDate(ordersku.datetime);
              sku["nombre_invitado"] = ordersku.nombre_invitado;
              sku.dedicacion_invitado = ordersku.dedicacion_invitado
              sku["orderid"] = ordersku.orderid;
              sku["LASTNAME"] = "";//data.response.order[key].LASTNAME;
              sku["TOTAL"] = sku.TOTAL || 0;
              sku["EVENTID"] = eventId;
              sku["SKU"] = sku.sku
              let match = data.response.productos.find(e => e.sku === sku.sku);
              if (!match) {
                console.log("buscamos regalo extra para", sku.sku)
                let url_path_prd_prod = process.env.REACT_APP_APIPRD_CONFIG
                const response = await axios.get(url_path_prd_prod, {
                  params: {
                    custom: true,
                    SKU: sku.sku
                  },
                  headers: {
                    "Content-Type": "application/json"
                  }
                });
                match = response.data.result[0];
                match.isExtra = true
              }

              sku.QUANTITY = sku?.quantity
              sku.PRICE = (match.price ?? 0)
              sku.isExtra = match.isExtra
              sku.name = match?.specific_name
              sku.TOTAL = sku.quantity * (match.price ?? 0)
              sku.product_id = match.id
              if (validOrders.indexOf(Number(ordersku.orderid)) >= 0) {
                orderskus.push(sku);
              }
            }
          }
        }
      });
    console.log("arr",arr)
    console.log("orderskus",orderskus)

    arr = arr.sort(function (a, b) {
      return parseInt(a.orderid) - parseInt(b.orderid);
    });

    orderskus = orderskus.sort(function (a, b) {
      return parseInt(a.orderid) - parseInt(b.orderid);
    });
    var datosOrdenes = [];
    var datosRackOrdenes = [];
    tipopedidos.map(function (tipo) {
      var orderid;
      var tipopedido = tipo.VALOR;
      var flujo = tipo.ID_HFLUJO;

      ordenes.map(function (orden) {
        if (flujo == orden.ID_HFLUJO) {
          orderid = orden.VALOR;
        }
      });
      datosOrdenes.push({
        flujo: flujo,
        orderid: Number(orderid),
        tipopedido: tipopedido,
      });
    });

    posicionracks.map(function (tipo) {
      var orderid;
      var posicion_rack = tipo.VALOR;
      var flujo = tipo.ID_HFLUJO;

      ordenes.map(function (orden) {
        if (flujo == orden.ID_HFLUJO) {
          orderid = orden.VALOR;
        }
      });
      datosRackOrdenes.push({
        flujo: flujo,
        orderid: Number(orderid),
        posicion_rack: posicion_rack,
      });
    });
    console.log("posicionracks", posicionracks)
    console.log("datosRackOrdenes", datosRackOrdenes)
    console.log("datosOrdenes", datosOrdenes)
    console.log("orderskus", orderskus)
    orderskus.map(function (orden) {
      var tipoPedido = "";
      datosOrdenes.map(function (dorden) {
        if (Number(orden.orderid) === Number(dorden.orderid)) {
          tipoPedido = dorden.tipopedido;
        }
      });
      if (tipoPedido !== "") {
        orden["ORDERTYPE"] = tipoPedido;
      } else {
        orden["ORDERTYPE"] = "Pedido online";
      }
    });

    console.log("ordenes", ordenes);
    console.log("arr", arr);
    arr.map(function (orden) {
      var tipoPedido = "";
      datosOrdenes.map(function (dorden) {
         if ( Number(orden.orderid) === Number(dorden.orderid)) {
          tipoPedido = dorden.tipopedido;
        }
      });
      orden["tipopedido"] = tipoPedido;

      var posicion_rack = "";
      datosRackOrdenes.map(function (dorden) {
         if ( Number(orden.orderid) === Number(dorden.orderid)) {
          posicion_rack = dorden.posicion_rack;
        }
      });
      orden["posicion_rack"] = posicion_rack;

      var flowId = "";
      ordenes.map(function (dorden) {
        if (Number(orden.orderid) === Number(dorden.VALOR)) {
          flowId = dorden.ID_HFLUJO;
        }
      });
      orden["flowId"] = flowId;
    });
    console.log("orderskus", orderskus)
    const tableData = this.state.tableData;
    tableData.rows = orderskus;

    this.setState({
      ...this.state,
      loadingData: false,
      orders: arr,
      ordersPicked: ordersPicked,
      store_url: API_CONFIG.casaideas,
      validOrders: validOrders,
      montoEvento: montoEvento,
      customerinfo: customerinfo,
      addinfo: addinfo,
      regalos: regalos,
      token: token,
      WOTaskId: WOTaskId,
      WO_Id: WO_Id,
      locked: locked,
    });
  };

  toggleModal = (nr) => () => {
    let modalNumber = "modal" + nr;
    this.setState({
      [modalNumber]: !this.state[modalNumber],
    });
  };

  render() {
    return (
      <>
        <LockOverlay visible={this.state.locked && !this.state.loadingData} />
        {this.state.loadingData ? (
          <Loader idLoading={this.state.loadingData} />
        ) : (
          <>
            <Loader idLoading={this.state.isExecuting} />

            <h3
              style={{
                zIndex: "1000",
                fontWeight: "600",
                color: "#000",
                rginLeft: "0.5rem",
              }}
            >
              {" "}
              Datos del Evento
            </h3>

            <MDBRow className="pl-2">
              <MDBCol
                sm="12"
                style={{ fontSize: "1.25rem", fontWeight: "bold" }}
              >
                Datos del Cliente
              </MDBCol>
            </MDBRow>
            <MDBRow className="pl-2">
              {this.state.customerinfo.map((c, index) => (
                <MDBCol key={"ci" + index} sm="6">
                  <MDBInput
                    key={"ci2" + index}
                    value={c.value}
                    disabled={true}
                    label={c.name}
                  ></MDBInput>
                </MDBCol>
              ))}
            </MDBRow>

            <MDBRow className="pl-2">
              <MDBCol sm="6" md="3" lg="2" style={{ fontSize: "1.25rem" }}>
                C&oacute;digo Evento:
              </MDBCol>
              <MDBCol sm="6" md="3" lg="4" style={{ fontSize: "1.25rem" }}>
                <span
                  style={{
                    fontWeight: "600",
                  }}
                >
                  {this.state.eventId}
                </span>
              </MDBCol>
            </MDBRow>

            <MDBRow className="pl-2">
              <MDBCol sm="6" md="3" lg="2" style={{ fontSize: "1.25rem" }}>
                Nombre Evento:
              </MDBCol>
              <MDBCol sm="6" md="3" lg="4" style={{ fontSize: "1.25rem" }}>
                <span
                  style={{
                    fontWeight: "600",
                  }}
                >
                  {this.state.eventName}
                </span>
              </MDBCol>
              <MDBCol sm="6" md="3" lg="2" style={{ fontSize: "1.25rem" }}>
                Fecha del Evento:
              </MDBCol>
              <MDBCol sm="6" md="3" lg="4" style={{ fontSize: "1.25rem" }}>
                <span
                  style={{
                    fontWeight: "600",
                  }}
                >
                  {this.state.eventDate}
                </span>
              </MDBCol>
            </MDBRow>

            <MDBRow className="pl-2">
              <MDBCol sm="6" md="3" lg="2" style={{ fontSize: "1.25rem" }}>
                Tipo de Evento:
              </MDBCol>
              <MDBCol sm="6" md="3" lg="4" style={{ fontSize: "1.25rem" }}>
                <span
                  style={{
                    fontWeight: "600",
                  }}
                >
                  {this.state.eventType}
                </span>
              </MDBCol>
              <MDBCol sm="6" md="3" lg="2" style={{ fontSize: "1.25rem" }}>
                Fecha Fin Recepcion Regalos:
              </MDBCol>
              <MDBCol sm="6" md="3" lg="4" style={{ fontSize: "1.25rem" }}>
                <span
                  style={{
                    fontWeight: "600",
                  }}
                >
                  {this.state.eventEndDate}
                </span>
              </MDBCol>
            </MDBRow>

            <MDBRow className="pl-2">
              <MDBCol sm="6" md="3" lg="2" style={{ fontSize: "1.25rem" }}>
                Cantidad de Pedidos:
              </MDBCol>
              <MDBCol sm="6" md="3" lg="4" style={{ fontSize: "1.25rem" }}>
                <span
                  style={{
                    fontWeight: "600",
                  }}
                >
                  {this.state.orders.length}
                </span>
              </MDBCol>
              <MDBCol sm="6" md="3" lg="2" style={{ fontSize: "1.25rem" }}>
                Monto Total:
              </MDBCol>
              <MDBCol sm="6" md="3" lg="4" style={{ fontSize: "1.25rem" }}>
                <span
                  style={{
                    fontWeight: "600",
                  }}
                >
                  { this.state.montoEvento.toFixed(2) + "Bs."}
                </span>
              </MDBCol>
            </MDBRow>

            {/*
				   	<MDBRow className="pl-2" > 
				   		 
							<MDBCol sm="6" md="3" lg="2" style={{fontSize:"1.25rem"}} >
								Nombre de quien recibe los regalos:
							</MDBCol>  
							<MDBCol sm="6" md="3" lg="4" style={{fontSize:"1.25rem"}} >
							 
								<span style={{ 
											   	 	fontWeight:"600", 
											   	}}> 
								 {this.state.nombre_recepcion}
								</span>
							</MDBCol>  

							<MDBCol sm="6" md="3" lg="2" style={{fontSize:"1.25rem"}} >
								Regalos envueltos:
							</MDBCol>  
							<MDBCol sm="6" md="3" lg="4" style={{fontSize:"1.25rem"}} >
							 
								<span style={{ 
											   	 	fontWeight:"600", 
											   	}}> 
								 {this.state.regalos}
								</span>
							</MDBCol>  
						 
				   	</MDBRow> 
				   	 */}

            <MDBRow className="pl-2">
              <MDBCol
                sm="12"
                style={{ fontSize: "1.25rem", fontWeight: "bold" }}
              >
                Datos de Direccion
              </MDBCol>
            </MDBRow>
            <MDBRow className="pl-2">
              {this.state.addinfo.map((c) => (
                <MDBCol sm="12">
                  <MDBInput
                    value={c.value}
                    disabled={true}
                    label={c.name}
                  ></MDBInput>
                </MDBCol>
              ))}
            </MDBRow>

            {this.state.orders.map((event) => (
              <p key={"event_" + event.id} className="mt-3 mx-2">
                <Event
                  event={event}
                  handlePick={this.handlePick}
                  handleChange={this.handleChange}
                  handleSetRack={this.handleSetRack}
                />
              </p>
            ))}

            <MDBRow>
              <MDBCol
                sm="12"
                md="12"
                lg="12"
                xl="12"
                className="text-right justify-content-right"
              >
                <ExcelFile
                  filename={"export-orders-evento." + this.state.eventId}
                  element={
                    <MDBBtn key="find" size="sm" color="success">
                      Exportar a Excel
                    </MDBBtn>
                  }
                >
                  <ExcelSheet
                    data={this.state.tableData.rows}
                    name="Lista de Pedidos"
                  >
                    <ExcelColumn label="Codigo Evento" value="EVENTID" />
                    <ExcelColumn label="Pedido" value="orderid" />
                    <ExcelColumn label="Fecha Pedido" value="DATEADDED" />
                    <ExcelColumn label="Nombre Invitado" value="nombre_invitado" />
                    <ExcelColumn label="Dedicatoria" value="dedicacion_invitado" />
                    <ExcelColumn label="Monto Pedido" value="TOTAL" />
                    <ExcelColumn label="SKU" value="SKU" />
                    <ExcelColumn label="Cantidad" value="QUANTITY" />
                    <ExcelColumn label="Precio Unitario" value="PRICE" />
                  </ExcelSheet>
                </ExcelFile>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol
                sm="12"
                md="12"
                lg="12"
                xl="12"
                className="text-left justify-content-left"
              >
                <Table
                  tableData={this.state.tableData}
                  scroll={{ x: 950, y: 300 }}
                />
              </MDBCol>
            </MDBRow>
          </>
        )}

        <ToastContainer
          hideProgressBar={true}
          newestOnTop={false}
          position={"bottom-right"}
          autoClose={3000}
        />
      </>
    );
  }
}

class Event extends React.Component {
  render() {
    return (
      <MDBCard className="">
        <div className="media m-2">
          <div className="media-body mb-3 mb-lg-3">
            <hr className="hr-bold my-2" />
            {this.props.event.orderid && (
              <>
                <div className="font-smaller mb-0">
                  <MDBRow>
                    <MDBCol
                      sm="11"
                      className="align-items-left justify-content-left"
                    >
                      <h5
                        style={{
                          zIndex: "1000",
                          fontWeight: "600",
                          color: "#000",
                        }}
                      >
                        <MDBIcon icon="shopping-basket" />
                        <span>Pedido: {this.props.event.orderid}</span>
                      </h5>
                    </MDBCol>

                    <MDBCol style={{ textAlign: "center" }} sm="1">
                      <MDBBadge
                        color={
                          this.props.event.isPicked === -1 ? "grey" : "success"
                        }
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          this.props.handlePick(this.props.event.orderid)
                        }
                      >
                        <MDBIcon
                          far={this.props.event.isPicked === -1 ? false : true}
                          size="2x"
                          icon={
                            this.props.event.isPicked === -1
                              ? "check-square"
                              : "check-square"
                          }
                        />
                      </MDBBadge>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className="align-items-left justify-content-left">
                    <MDBCol md="12">
                      <h5
                        style={{
                          zIndex: "1000",
                          fontWeight: "600",
                          color: "#000",
                        }}
                      >
                        {" "}
                        Nombre Cliente:{" "}
                        {this.props.event.nombre}

                      </h5>
                    </MDBCol>
                  </MDBRow>

                  <MDBRow className="align-items-left justify-content-left">
                    <MDBCol sm="9" md="2">
                      <MDBInput
                        value={this.props.event.posicion_rack}
                        name={this.props.event.orderid}
                        onChange={this.props.handleChange}
                        type="text"
                        label={"Posici\u00F3n Rack"}
                      ></MDBInput>
                    </MDBCol>

                    <MDBCol sm="3" md="2">
                      <MDBBtn
                        color="secondary"
                        onClick={() => {
                          this.props.handleSetRack(this.props.event.orderid);
                        }}
                        className="mt-4"
                        size="sm"
                      >
                        Guardar
                      </MDBBtn>
                    </MDBCol>
                  </MDBRow>
                </div>

                <MDBCard className="m-2">
                  <MDBRow className="align-items-left justify-content-left">
                    <MDBCol md="12">
                      <h6
                        style={{
                          zIndex: "1000",
                          fontWeight: "600",
                          color: "#000",
                        }}
                      >
                        {" "}
                        Productos
                      </h6>
                    </MDBCol>
                  </MDBRow>

                  {this.props.event.products.map((item) => (
                    <>
                      <div className="media m-1 p-1">
                        <span className="h4-responsive font-weight-bold mr-3">

                          <img
                            src={item.image}
                            alt="thumbnail"
                            height="60px"
                            width="60px"
                            className="img-thumbnail"
                          />
                        </span>
                        <div className="media-body mb-3 mb-lg-3">
                          <span className="h6 mt-0 font-weight-bold">
                            {item.name}{" "}{item.isExtra ? "(Regalo extra)" : ""}
                          </span>{" "}
                          <hr className="hr-bold my-2" />
                          {item.product_id && (
                            <React.Fragment>
                              <p className="font-smaller mb-0">
                                <MDBRow className="align-items-left justify-content-left">
                                  <MDBCol md="12">
                                    <MDBIcon icon="shopping-basket" /> Codigo:{" "}
                                    {item.sku}
                                  </MDBCol>
                                </MDBRow>
                                <MDBRow className="align-items-left justify-content-left">
                                  <MDBCol md="12">
                                    <MDBIcon icon="barcode" /> SKU: {item.sku}
                                  </MDBCol>
                                </MDBRow>
                              </p>
                            </React.Fragment>
                          )}
                        </div>
                      </div>

                      {item.quantity && (
                        <>
                          <p className="p-2 mb-4  blue-grey lighten-5 blue-grey lighten-5">
                            {"Cantidad: " +
                              item.quantity +
                              ", Precio unitario: " +
                              item.price +
                              "Bs. Total " +
                              item.total}
                          </p>
                        </>
                      )}
                    </>
                  ))}
                </MDBCard>
                <MDBRow>
                  <MDBCol sm="12" style={{ textAlign: "right" }}>
                    <h6
                      style={{
                        zIndex: "1000",
                        fontWeight: "600",
                        color: "#000",
                        marginRight: 15,
                      }}
                    >
                      <span>
                        Total Pedido:{" "}
                        {this.props.event.total ? this.props.event.total : 0}
                      </span>
                    </h6>
                  </MDBCol>
                </MDBRow>
              </>
            )}
          </div>
        </div>
      </MDBCard>
    );
  }
}

export default externalForm01;
